import type { LinkDef } from '@hanzo/ui/types'

export default [
  {
    title: 'Network',
    href: "https://lux.network/",
    variant: 'linkFG'
  },
  {
    title: 'Lux Bridge',
    href: "https://bridge.lux.network/",
  },
  {
    title: 'Lux Explorer',
    href: "https://explore.lux.network/",
  },
  {
    title: 'Lux Wallet',
    href: "https://wallet.lux.network/",
  },
  {
    title: 'Lux Safe',
    href: "https://safe.lux.network/",
  },
  {
    title: 'Lux Build',
    href: "https://lux.build",
  },
  {
    title: 'Lux Coin',
    href: "https://lux.network/coin",
  },
  {
    title: 'Governance',
    href: "https://lux.vote",
  },
  {
    title: 'Open Source',
    href: 'https://github.com/luxfi',
  },
  {
    title: 'Launch Subnet',
    href: 'https://docs.lux.network/build/subnet/hello-subnet',
  },
] satisfies LinkDef[]
